<!-- components/Footer.vue -->
<script setup lang="ts">
// Les liens pointent vers le site principal courdescomptes.bj
</script>

<template>
  <footer class="bg-[#04406E] text-white">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div class="grid grid-cols-1 md:grid-cols-12 gap-8">

        <!-- Colonne 1 : Logo + Description -->
        <div class="md:col-span-4 space-y-2">
         <div class="flex items-center space-x-4">
          <img
            src="../../assets/images/logo-cour-des-comptes.png"
            alt="Logo Cour des Comptes"
            class="h-20"
          />
        </div>
          <p class="text-sm text-blue-200 leading-relaxed">
            La Cour des comptes est la plus haute juridiction de l’État en matière de contrôle des comptes publics.
          </p>
        </div>

        <!-- Colonne 2 : Publications -->
        <div class="md:col-span-2">
          <h3 class="text-lg font-semibold mb-4">Publications</h3>
          <ul class="space-y-2 text-sm">
            <li>
              <a href="https://courdescomptes.bj/rapports" target="_blank" rel="noopener noreferrer" class="text-blue-200 hover:text-white transition">
                Rapports
              </a>
            </li>
            <li>
              <a href="https://courdescomptes.bj/discours" target="_blank" rel="noopener noreferrer" class="text-blue-200 hover:text-white transition">
                Discours
              </a>
            </li>
            <li>
              <a href="https://courdescomptes.bj/recherche-avancee" target="_blank" rel="noopener noreferrer" class="text-blue-200 hover:text-white transition">
                Recherches
              </a>
            </li>
            <li>
              <a href="https://courdescomptes.bj/actualites" target="_blank" rel="noopener noreferrer" class="text-blue-200 hover:text-white transition">
                Actualités
              </a>
            </li>
            <li>
              <a href="https://courdescomptes.bj/faq" target="_blank" rel="noopener noreferrer" class="text-blue-200 hover:text-white transition">
                Foire aux questions
              </a>
            </li>
            <li>
              <a href="https://courdescomptes.bj/mediatheque" target="_blank" rel="noopener noreferrer" class="text-blue-200 hover:text-white transition">
                Médiathèque
              </a>
            </li>
          </ul>
        </div>

        <!-- Colonne 3 : Contact -->
        <div class="md:col-span-3">
          <h3 class="text-lg font-semibold mb-4">Pages</h3>
          <ul class="space-y-2 text-sm text-blue-200">
            <li>
              <a href="mailto:contact@courdescomptes.bj" class="hover:text-white transition">
                contact@courdescomptes.bj
              </a>
            </li>
            <li class="leading-relaxed">
              265 Rue de la République, BP 1000, Cotonou, Bénin
            </li>
            <li>
              <a href="tel:+2290195309244" class="hover:text-white transition">
                (+229) 01 95 30 92 44
              </a>
            </li>
          </ul>
        </div>

        <!-- Colonne 4 : Newsletter -->
        <div class="md:col-span-3">
          <h3 class="text-lg font-semibold mb-4">Newsletter</h3>
          <form class="space-y-3">
            <input
              type="email"
              placeholder="nom@email.com"
              class="w-full px-4 py-2 rounded-full bg-gray-800 text-white placeholder-gray-400 text-sm focus:outline-none focus:ring-2 focus:ring-green-500"
            />
            <button
              type="submit"
              class="w-full bg-green-600 text-white font-medium text-sm py-2 rounded-full hover:bg-green-700 transition"
            >
              s'abonner
            </button>
          </form>
        </div>
      </div>

      <!-- Ligne de séparation -->
      <hr class="my-8 border-gray-700" />

      <!-- Bas du footer -->
      <div class="flex flex-col md:flex-row justify-between items-center text-xs text-blue-300">
        <p>© 2025 Cour des Comptes – République du Bénin – Tous droits réservés</p>
        <a href="https://courdescomptes.bj/politique-confidentialite" target="_blank" rel="noopener noreferrer" class="hover:text-white transition mt-2 md:mt-0">
          Politique de confidentialité
        </a>
      </div>

      <!-- Drapeau Bénin -->
      <div class="flex justify-center md:justify-center space-x-4 mt-4">
        <span class="w-2 h-2 rounded-full bg-green-500"></span>
        <span class="w-2 h-2 rounded-full bg-yellow-500"></span>
        <span class="w-2 h-2 rounded-full bg-red-600"></span>
      </div>
    </div>
  </footer>
</template>